import { render, staticRenderFns } from "./stroeImgUploda.vue?vue&type=template&id=a0959fe6&scoped=true"
import script from "./stroeImgUploda.vue?vue&type=script&lang=js"
export * from "./stroeImgUploda.vue?vue&type=script&lang=js"
import style0 from "./stroeImgUploda.vue?vue&type=style&index=0&id=a0959fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0959fe6",
  null
  
)

export default component.exports